// extracted by mini-css-extract-plugin
export var active = "_bh-2";
export var highlight = "_bh-1";
export var highlightLayer = "_bh-0";
export var issuePopover = "_bh-3";
export var statusIcon = "_bh-4";